// extracted by mini-css-extract-plugin
module.exports = {"inner":"listtag_inner_1yiia","title":"listtag_title_2RAjj","total":"listtag_total_2q2X7","status":"listtag_status_3r-QU","operating":"listtag_operating_15B1L"};